export const produtos = [
  {
    id: 1,
    nome: "Urso fofinho coração",
    descricao: "urso segurando coração bem fofinho",
    categoria: "Presentes",
    imagens: [
      require("@/assets/images/urso-coracao/urso-coracao1.png"),
      require("@/assets/images/urso-coracao/urso-coracao2.png"),
      require("@/assets/images/urso-coracao/urso-coracao3.png"),
      require("@/assets/images/urso-coracao/urso-coracao5.png"),
      require("@/assets/images/urso-coracao/urso-coracao6.png"),
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (8 CM)", quantidade: 1, valor: 30.51 },
      { id: 2, tamanho: "Pequeno (8 CM)", quantidade: 3, valor: 25.58 },
      { id: 3, tamanho: "Pequeno (8 CM)", quantidade: 7, valor: 23.60 },
    ],
    cores: [
      { id: 2, nome: "Azul", hexadecimal: "#33A1CE" },
      { id: 1, nome: "Marrom", hexadecimal: "#912F1F" },
      { id: 6, nome: "Branco", hexadecimal: "#E8EBEB" },
      { id: 3, nome: "Verde", hexadecimal: "#19601A" },
      { id: 4, nome: "Amarelo", hexadecimal: "#FFE41E" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (8 CM)" },
    ]
  },
  {
    id: 2,
    nome: "Urso fofinho coração brilha no escuro",
    descricao: "urso segurando coração bem fofinho brilha no escuro",
    categoria: "Presentes",
    imagens: [
      require("@/assets/images/urso-coracao/urso-coracao4.png"),
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (8 CM)", quantidade: 1, valor: 35.64 },
      { id: 2, tamanho: "Pequeno (8 CM)", quantidade: 3, valor: 31.97 },
      { id: 3, tamanho: "Pequeno (8 CM)", quantidade: 7, valor: 29.80 },
    ],
    cores: [
      { id: 2, nome: "Verde Brilha no escuro", hexadecimal: "#87E67E" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (8 CM)" },
    ]
  },
  {
    id: 3,
    nome: "Darth Vader detalhado",
    descricao: "darth Vader detalhado",
    categoria: "Personagens",
    imagens: [
      require("@/assets/images/darth-vader/darth-vader1.png"),
      require("@/assets/images/darth-vader/darth-vader2.png"),
      require("@/assets/images/darth-vader/darth-vader3.png"),
      require("@/assets/images/darth-vader/darth-vader4.png"),
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (7 CM)", quantidade: 1, valor: 32.05 },
      { id: 2, tamanho: "Pequeno (7 CM)", quantidade: 3, valor: 26.28 },
      { id: 3, tamanho: "Pequeno (7 CM)", quantidade: 7, valor: 21.28 },
      { id: 4, tamanho: "Medio (10 CM)", quantidade: 1, valor: 50.42 },
      { id: 5, tamanho: "Medio (10 CM)", quantidade: 3, valor: 44.12 },
      { id: 6, tamanho: "Medio (10 CM)", quantidade: 5, valor: 43.56 },
      { id: 7, tamanho: "Grande (15 CM)", quantidade: 1, valor: 98.77 },
      { id: 8, tamanho: "Grande (15 CM)", quantidade: 3, valor: 92.95 }
    ],
    cores: [
      { id: 1, nome: "Preto", hexadecimal: "#141213" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (7 CM)" },
      { id: 2, nome: "Medio (10 CM)" },
      { id: 3, nome: "Grande (15 CM)" },
    ]
  },
  {
    id: 4,
    nome: "Tampa caneta sabre de luz",
    descricao: "Tampa de caneta de sabre de luz para carnetas.",
    categoria: "Presentes",
    imagens: [
      require("@/assets/images/tampa-bic-sabre-luz/bic-sabre-luz3.png"),
      require("@/assets/images/tampa-bic-sabre-luz/bic-sabre-luz1.png"),
      require("@/assets/images/tampa-bic-sabre-luz/bic-sabre-luz2.png"),
     
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (4 CM)", quantidade: 1, valor: 10.67 },
      { id: 2, tamanho: "Pequeno (4 CM)", quantidade: 5, valor: 3.26},
      { id: 3, tamanho: "Pequeno (4 CM)", quantidade: 12, valor: 2.29},
    ],
    cores: [
      { id: 1, nome: "Prata", hexadecimal: "#B9C4D5" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (4 CM)" },
    ]
  },
  {
    id: 5,
    nome: "Tampa caneta sabre de luz dois lados",
    descricao: "Tampa de caneta de sabre de luz dois lados para carnetas.",
    categoria: "Presentes",
    imagens: [
      require("@/assets/images/tampa-bic-sabre-luz-2-lados/tampa-bic-2-lados.png"),
      require("@/assets/images/tampa-bic-sabre-luz-2-lados/tampa-bic-2-lados2.png")
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (4 CM)", quantidade: 1, valor: 11.59 },
      { id: 2, tamanho: "Pequeno (4 CM)", quantidade: 3, valor: 3.79 },
      { id: 3, tamanho: "Pequeno (4 CM)", quantidade: 12, valor: 2.78 },
    ],
    cores: [
      { id: 1, nome: "Prata", hexadecimal: "#B9C4D5" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (4 CM)" },
    ]
  },
  {
    id: 6,
    nome: "Chaveiro Stich",
    descricao: "Chaveiro Stich.",
    categoria: "Chaveiros",
    imagens: [
      require("@/assets/images/chaveiro-stich/chaveiro-stich-1.png"),
      require("@/assets/images/chaveiro-stich/chaveiro-stich-2.png")
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (5 CM)", quantidade: 1, valor: 20.77 },
      { id: 2, tamanho: "Pequeno (5 CM)", quantidade: 3, valor: 15.6},
      { id: 3, tamanho: "Pequeno (5 CM)", quantidade: 6, valor: 14.28 },
    ],
    cores: [
      { id: 1, nome: "Azul claro", hexadecimal: "#33A1CE" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (5 CM)" },
    ]
  },
  {
    id: 7,
    nome: "Chaveiro KB",
    descricao: "Chaveiro KB.",
    categoria: "Chaveiros",
    imagens: [
      require("@/assets/images/chaveiro-kb/chaveiro-kb-1.png"),
      require("@/assets/images/chaveiro-kb/chaveiro-kb-2.png"),
      require("@/assets/images/chaveiro-kb/chaveiro-kb-3.png")
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (4 CM)", quantidade: 2, valor: 7.90 },
      { id: 2, tamanho: "Pequeno (4 CM)", quantidade: 6, valor: 4.92},
      { id: 3, tamanho: "Pequeno (4 CM)", quantidade: 12, valor: 4.23 },
    ],
    cores: [
      { id: 1, nome: "Preto", hexadecimal: "#141213" },
      { id: 2, nome: "Bege", hexadecimal: "#F1CB8D" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (4 CM)" },
    ]
  },
  {
    id: 8,
    nome: "Chaveiro Jogo da Velha",
    descricao: "Chaveiro Jogo da Velha.",
    categoria: "Chaveiros",
    imagens: [
      require("@/assets/images/chaveiro-jogo-velha/chaveiro-jogo-velha-1.png"),
      require("@/assets/images/chaveiro-jogo-velha/chaveiro-jogo-velha-2.png"),
      require("@/assets/images/chaveiro-jogo-velha/chaveiro-jogo-velha-3.png"),
      require("@/assets/images/chaveiro-jogo-velha/chaveiro-jogo-velha-4.png"),
      require("@/assets/images/chaveiro-jogo-velha/chaveiro-jogo-velha-5.png"),
      require("@/assets/images/chaveiro-jogo-velha/chaveiro-jogo-velha-6.png"),
    ],
    precos: [
      { id: 1, tamanho: "Pequeno (5.6 CM)", quantidade: 1, valor: 26.64 },
      { id: 2, tamanho: "Pequeno (5.6 CM)", quantidade: 6, valor: 18.65 },
      { id: 3, tamanho: "Pequeno (5.6 CM)", quantidade: 12, valor: 15.97 },
    ],
    cores: [
      { id: 1, nome: "Vermelho", hexadecimal: "#EA001C" },
      { id: 2, nome: "Amarelo", hexadecimal: "#FFE41E" },
      { id: 2, nome: "Preto", hexadecimal: "#141213" },
      { id: 2, nome: "Azul", hexadecimal: "#002BC2" },
      { id: 2, nome: "Verde", hexadecimal: "#19601A" },
    ],
    tamanhos: [
      { id: 1, nome: "Pequeno (5.6 CM)" },
    ]
  },
  
  // Adicione mais produtos...
]

export const categorias = [
  "Presentes",
  "Utilitários",
  "Personagens",
  "Chaveiros"
  // Adicione mais categorias...
]